import { render, staticRenderFns } from "./SaleSearchResult.vue?vue&type=template&id=50c6cb56&scoped=true"
import script from "./SaleSearchResult.vue?vue&type=script&lang=js"
export * from "./SaleSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6cb56",
  null
  
)

export default component.exports